<script setup lang="ts">
import type { IFeatureProps } from '@/pages/forLaywers/model/types/popularityFeatures';

defineProps<IFeatureProps>();

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['popularity-feature', { _mobile: isMobile }]">
    <div class="popularity-feature__info">
      <span v-if="feature.iconName" class="popularity-feature__icon">
        <AppIcon :name="feature.iconName" />
      </span>
      <span v-if="feature.countTextLeft" class="popularity-feature__count-text">
        {{ feature.countTextLeft }}
      </span>
      <span class="popularity-feature__count">
        {{ feature.count }}
      </span>
      <span
        v-if="feature.countTextRightSmall"
        class="popularity-feature__count-text _small"
      >
        {{ feature.countTextRightSmall }}
      </span>
      <span v-if="feature.countTextRight" class="popularity-feature__count-text">
        {{ feature.countTextRight }}
      </span>
    </div>
    <div class="popularity-feature__text" v-html="feature.text"></div>
  </div>
</template>

<style lang="less">
.popularity-feature {
  .flex-column(@size-x6);

  background-color: @color-black-haze;
  height: 100%;
  padding: 96px 58px;
  border-radius: @main-size;

  @media @1366 {
    gap: 14px;
  }

  &__text {
    font-size: @size-x6;
    font-weight: 400;
    line-height: @size-x7;
    text-align: center;
    max-width: 234px;

    @media @1366 {
      font-size: 18px;
      line-height: @size-x5;
    }

    @media @tablet {
      font-size: @size-x4;
      line-height: 18px;
    }
  }

  &__info {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__icon {
    width: 34px;
    height: 34px;
  }

  &__count {
    font-size: @size-x10;
    font-weight: 600;
    line-height: 41px;
    white-space: nowrap;
    margin: 0 @main-size;
  }

  &__count-text {
    font-size: @size-x6;
    font-weight: 400;
    line-height: @size-x7;

    &._small {
      font-size: 13px;
      font-weight: 500;
      line-height: 18px;
      width: 56px;
    }
  }

  &._mobile {
    gap: 6px;
    height: auto;
    padding: 0;
  }

  &._mobile &__text {
    font-size: @size-x4;
    font-weight: 400;
    line-height: 22px;
  }

  &._mobile &__count {
    margin: 0 5px;
    font-size: 43px;
    line-height: 50px;
  }

  &._mobile &__count-text {
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
  }
}
</style>
